module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"payment_amount":"Payment Amount","payment_date":"Payment Date","cancel":"Cancel","submit":"Submit"}}')
  delete Component.options._Ctor
}
